import React from "react";
import classNames from "classnames";
import { Message } from "Components/Icons";
import { VisualIcon } from "../../../Components";

import classes from "./MessageIcon.module.scss";

export interface MessageIconProps
   extends React.HTMLAttributes<HTMLDivElement> {}

const MessageIcon: React.FC<MessageIconProps> = ({ className, ...props }) => (
   <VisualIcon className={classNames(classes.icon, className)} {...props}>
      <Message />
   </VisualIcon>
);

export default MessageIcon;
